import React, { PropTypes, Component } from 'react'
import PlayIcon from './icons/play.svg'
import PauseIcon from './icons/pause.svg'

class PlayButton extends Component {
  shouldComponentUpdate (nextProps) {
    let { playing } = this.props
    return playing !== nextProps.playing
  }

  render () {
    let { playing, className } = this.props
    return (
      <button type='button' className={className} onClick={this.props.handlePlay}>
        {playing
          ? <img alt='Playing' src={PauseIcon} />
          : <img alt='Paused' src={PlayIcon} />}
      </button>
    )
  }
}

PlayButton.propTypes = {
  className: PropTypes.string,
  playing: PropTypes.bool,
  handlePlay: PropTypes.func
}

PlayButton.defaultProps = {
  playing: false
}

export default PlayButton



/** WEBPACK FOOTER **
 ** ./src/components/PlayButton.js
 **/